import {
	createStore,
	createContainer,
	createActionsHook,
	createHook,
	type StoreActionApi,
} from '@atlassian/react-sweet-state';
import { type Actions, actions } from './actions';
import type { ContainerProps, State } from './types';

const initialState = {
	selectedProjectAris: [],
	sprintAutoDiscoveryLimit: null,
	showReactionsButtonForSuggestions: {},
};

const Store = createStore<State, Actions, ContainerProps>({
	initialState,
	actions,
	name: 'jira.periscope.work-suggestion-store',
});

const handlePropsChange =
	() =>
	(
		{ setState }: StoreActionApi<State>,
		{ projectAris, sprintAutoDiscoveryLimit }: ContainerProps,
	) => {
		if (projectAris.length > 0) {
			setState({ selectedProjectAris: [...projectAris], sprintAutoDiscoveryLimit });
		}
	};

export const WorkSuggestionsStateContainer = createContainer<State, Actions, ContainerProps>(
	Store,
	{
		onInit: handlePropsChange,
		onUpdate: handlePropsChange,
	},
);

export const useWorkSuggestionsContainer = createHook(Store);
export const useWorkSuggestionsActions = createActionsHook(Store);
